import { Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { useTranslation } from "react-i18next";

type MapDrawingToolbarProps = {
  deleteDisabled?: boolean;
  deleteLabel: string;
  drawLabel: string;
  drawStartedNotFinished?: boolean;
  editLabel: string;
  isDrawing: boolean;
  isEditing: boolean;
  onDeleteClick: () => void;
  onDrawClick: () => void;
  onEditClick: () => void;
  onEndDrawingClick?: () => void;
  primaryButtonsDisabled?: boolean;
  showEndDrawingButton?: boolean;
};

export const MapDrawingToolbar = ({
  deleteDisabled = false,
  deleteLabel,
  drawLabel,
  drawStartedNotFinished = false,
  editLabel,
  isDrawing,
  isEditing,
  onDeleteClick,
  onDrawClick,
  onEditClick,
  onEndDrawingClick,
  primaryButtonsDisabled = false,
  showEndDrawingButton = false,
}: MapDrawingToolbarProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="w-full flex-wrap justify-between rounded-xl bg-lds-surface-bright p-2 shadow-elevation400 border-ds-subtle">
      <Stack className="gap-2">
        <Button
          disabled={primaryButtonsDisabled}
          onClick={onDrawClick}
          size="sm"
          startIconName="SquareHalf"
          variant={isDrawing ? "primary" : "tertiary"}
        >
          {drawLabel}
        </Button>
        <Button
          disabled={primaryButtonsDisabled}
          onClick={onEditClick}
          size="sm"
          startIconName="Edit"
          variant={isEditing ? "primary" : "tertiary"}
        >
          {editLabel}
        </Button>
        <Button disabled={deleteDisabled} onClick={onDeleteClick} size="sm" startIconName="Trash" variant="error">
          {deleteLabel}
        </Button>
      </Stack>
      {onEndDrawingClick && showEndDrawingButton && drawStartedNotFinished ? (
        <Button onClick={onEndDrawingClick} size="sm" variant="success">
          {t("AddBuilding.outlineStep.finishDrawing")}
        </Button>
      ) : null}
    </Stack>
  );
};
